import React from "react";

import Trash from "../../../../assets/icons/bin.svg";

const Bin = (props) => {
  return (
    <div className={["bin", props.isSection ? "ml-auto" : ""].join(" ")}>
      <img src={Trash} alt="Trash" onClick={props.deleteHandler} />
    </div>
  );
};

export default Bin;
